import styled from 'styled-components'

export const Label = styled.span`
  margin-right: ${(props) => props.theme.mp.sm};
  font-weight: ${(props) => props.theme.font.weights.semiBold};
`

export const RequiredLabel = styled.p`
  color: ${(props) => props.theme.palette.dark};
  font-weight: ${(props) => props.theme.font.weights.light};
  font-size: ${(props) => props.theme.font.sizes.xsmall};
  font-style: italic;
  margin: 0;
  padding: 0;
`
